export default __webpack_public_path__ + "static/media/Brenda_Miller_AHV_In_Moms_We_Trust.3a0dcc1c.jpg";